import { useAuthStore } from '@/stores/useAuthStore'
import type { TeamRound } from '@/types/dde/teamRound.types'

import { createWebSocketTableStore } from '../table'

export const useTeamRoundStore = createWebSocketTableStore<
  TeamRound,
  TeamRound | TeamRound[],
  { tournamentId: number; teamNo: number; roundNo: number }
>({
  storeName: 'DDE Golf Pricing - Team Round',
  features: {
    pagination: false,
    sorting: false,
    filtering: false
  },
  websocketConfig: {
    getUrl: (params: { tournamentId: number; teamNo: number; roundNo: number }) =>
      `${import.meta.env.VITE_DDE_MSFP_WEBSOCKET}/golf/tournaments/${params.tournamentId}/round/${params.roundNo}/team/${params.teamNo}`,
    transformData: (rawData: TeamRound | TeamRound[]): TeamRound[] => {
      return Array.isArray(rawData) ? rawData : [rawData]
    },
    getAuthToken: () => useAuthStore.getState().token,
    shouldReuseConnection: (currentParams, newParams) =>
      currentParams?.tournamentId === newParams?.tournamentId &&
      currentParams?.teamNo === newParams?.teamNo &&
      currentParams?.roundNo === newParams?.roundNo
  }
})
